import React, { useMemo } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Label,
  Row,
} from "reactstrap";
import HandleDateTime from "../../../../Components/Common/HandleDateTime";
import TableContainer from "../../../../Components/Common/TableContainer";
import SettingsPanel from "../../components/SettingsPanel";

export default function SuperScribeSettings() {
  const fakeScribeListData = [
    {
      Id: "1",
      Name: "Scribe 1",
      Description: "Scribe 1 description",
      Location: "Scribe 1 location",
      Status: "Active",
      Src: "https://scribehow.com/embed/Creating_a_new_customer_profile_for_Pauls_Factory__W8KlFeMpQJi_UsVsY6Gb3Q?as=scrollable&skipIntro=true",
      Created: "2021-09-01T00:00:00.000Z",
      Updated: "2021-09-01T00:00:00.000Z",
    },
    {
      Id: "2",
      Name: "Scribe 1",
      Description: "Scribe 1 description",
      Location: "Scribe 1 location",
      Status: "Active",
      Src: "https://scribehow.com/embed/Creating_a_new_customer_profile_for_Pauls_Factory__W8KlFeMpQJi_UsVsY6Gb3Q?as=scrollable&skipIntro=true",
      Created: "2021-09-01T00:00:00.000Z",
      Updated: "2021-09-01T00:00:00.000Z",
    },
    {
      Id: "3",
      Name: "Scribe 1",
      Description: "Scribe 1 description",
      Location: "Scribe 1 location",
      Status: "Active",
      Src: "https://scribehow.com/embed/Creating_a_new_customer_profile_for_Pauls_Factory__W8KlFeMpQJi_UsVsY6Gb3Q?as=scrollable&skipIntro=true",
      Created: "2021-09-01T00:00:00.000Z",
      Updated: "2021-09-01T00:00:00.000Z",
    },
    {
      Id: "4",
      Name: "Scribe 1",
      Description: "Scribe 1 description",
      Location: "Scribe 1 location",
      Status: "Active",
      Src: "https://scribehow.com/embed/Creating_a_new_customer_profile_for_Pauls_Factory__W8KlFeMpQJi_UsVsY6Gb3Q?as=scrollable&skipIntro=true",
      Created: "2021-09-01T00:00:00.000Z",
      Updated: "2021-09-01T00:00:00.000Z",
    },
  ];
  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}> #{card.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Name",
        accessor: "Name",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                {card.row.original?.Name || "N/A"}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Description",
        accessor: "Description",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                {card.row.original?.Description || "N/A"}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Location",
        accessor: "Location",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                {card.row.original?.Location || "N/A"}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Status",
        accessor: "Status",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                {card.row.original?.Status || "N/A"}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Src",
        accessor: "Src",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div
                className="flex-grow-1 ms-2 name"
                title={card.row.original?.Src}
              >
                {card.row.original?.Src.length > 50
                  ? card.row.original?.Src.substring(0, 50) + "..."
                  : card.row.original?.Src || "N/A"}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Created",
        accessor: "Created",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                {HandleDateTime(card.row.original?.Created) || "N/A"}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Updated",
        accessor: "Updated",
        filterable: true,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                {HandleDateTime(card.row.original?.Updated) || "N/A"}
              </div>
            </div>
          </>
        ),
      },
    ],
    []
  );

  return (
    <SettingsPanel
      title="Scribe Settings"
      description="Scribe walkthrough recordings embedded across the platform."
    >
      <Card>
        <CardBody>
          <TableContainer
            columns={columns}
            data={fakeScribeListData || []}
            isGlobalFilter={false}
            isAddUserList={false}
            customPageSize={10}
            className="custom-header-css"
            divClass="table-responsive table-card mb-0"
            tableClass="align-middle table-nowrap"
            theadClass="text-muted"
            // handleLeadClick={handleLeadClicks}
            isLeadsFilter={false}
          />
        </CardBody>
      </Card>
      <div>
        <Card>
          <CardHeader>Add new Scribe</CardHeader>
          <CardBody>
            <div>
              <Row>
                <Col md={2}>
                  <Label>Name</Label>
                  <Input type="text" placeholder="Name" />
                </Col>
                <Col md={2}>
                  <Label>Description</Label>
                  <Input type="text" placeholder="Description" />
                </Col>
                <Col md={2}>
                  <Label>Location</Label>
                  <Input type="text" placeholder="Location" />
                </Col>
                <Col md={2}>
                  <Label>Status</Label>
                  <Input type="select" name="select" id="exampleSelect">
                    <option>Active</option>
                    <option>Inactive</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label>Src</Label>
                  <Input type="text" placeholder="Src" />
                </Col>
                <Col md={2} className={"d-flex align-items-end"}>
                  <Button color="primary w-100" className="mt-2">
                    Create
                  </Button>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </SettingsPanel>
  );
}
